import { render, staticRenderFns } from "./HelloWorld2.vue?vue&type=template&id=86e5a02a&scoped=true&"
import script from "./HelloWorld2.vue?vue&type=script&lang=js&"
export * from "./HelloWorld2.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld2.vue?vue&type=style&index=0&id=86e5a02a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e5a02a",
  null
  
)

export default component.exports